import { ChevronLeftIcon, ChevronRightIcon } from '@fronton/icons-react';
import { IconButton } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { arrowLeft, arrowRight } from './style';

type GalleryScrollArrowsProps = {
  showLeftArrow: boolean;
  showRightArrow: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
};

export const GalleryScrollArrows: React.FC<GalleryScrollArrowsProps> = ({
  showLeftArrow,
  showRightArrow,
  onScrollLeft,
  onScrollRight,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {showLeftArrow && (
        <IconButton
          className={arrowLeft}
          data-qa="photo-buyer-arrow-left"
          variant="primary"
          label={t('reviews.gallery.left')}
          size="m"
          onClick={onScrollLeft}
        >
          <ChevronLeftIcon type="outline" size="l" color="text-primary" />
        </IconButton>
      )}
      {showRightArrow && (
        <IconButton
          className={arrowRight}
          data-qa="photo-buyer-arrow-right"
          variant="primary"
          label={t('reviews.gallery.right')}
          size="m"
          onClick={onScrollRight}
        >
          <ChevronRightIcon type="outline" size="l" color="text-primary" />
        </IconButton>
      )}
    </>
  );
};
